import { render } from "./ReportView.vue?vue&type=template&id=20903052"
import script from "./ReportView.vue?vue&type=script&lang=js"
export * from "./ReportView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/ReportView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20903052"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20903052', __exports__)) {
    api.reload('20903052', __exports__)
  }
  
  module.hot.accept("./ReportView.vue?vue&type=template&id=20903052", () => {
    api.rerender('20903052', render)
  })

}


export default __exports__